import React from 'react';

import { PageContainer } from '../../components/PageContainer';
import List from '@mui/material/List/List';
import { NavLink } from 'react-router-dom';
import Typography from '@mui/material/Typography/Typography';
import Alert from '@mui/material/Alert/Alert';
import Stack from '@mui/material/Stack/Stack';
import { HowToArticles } from './HowTo';
import ListItem from '@mui/material/ListItem/ListItem';
import { AppBreadcrumbs, PageType } from '../../components/Breadcrumbs/Buttons';

export const HowToIndex = ({ notFound }: { notFound?: boolean }) => {

    return (
        <PageContainer>
            <Stack direction="column" spacing={2}>
                <AppBreadcrumbs crumbs={[
                    {
                        type: PageType.Home,
                        link: '/',
                        name: 'Home'
                    },
                    {
                        type: PageType.HowTo,
                        name: 'How To'
                    }
                ]} />
                <h1>How-to guides</h1>
                {notFound && <Alert severity="info">There's no guide at that address. Here are all the guides.</Alert>}
                <Typography color="text.secondary">New to Hack in a Box? Start with <NavLink to="/how/to/start">Run your first hackathon</NavLink>.</Typography>
                {
                    Array.from(new Set(HowToArticles.map(a => a.audience))).map(audience => (
                        <Stack key={audience} spacing={1}>
                            <Typography variant="h6" component="h2">{audience}</Typography>
                            <List disablePadding>
                                {
                                    HowToArticles.filter(a => a.audience === audience).map(article => (
                                        <ListItem key={article.link} disableGutters sx={{ display: 'block' }}>
                                            <NavLink to={`/how/to/${article.link}`}>{article.title}</NavLink>
                                            <Typography variant="body2" color="text.secondary">{article.summary}</Typography>
                                        </ListItem>
                                    ))
                                }
                            </List>
                        </Stack>
                    ))
                }
            </Stack>

        </PageContainer>
    )
}